import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { loadCurrentActor, webAuthEnabled, type AuthActor } from '../../lib/authClient';
import { LoadingSpinner } from '../ui/Card';

interface AuthGateProps {
  children: React.ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const [actor, setActor] = useState<AuthActor | null>(null);
  const [loading, setLoading] = useState(webAuthEnabled());
  const location = useLocation();

  useEffect(() => {
    if (!webAuthEnabled()) return;
    let active = true;
    setLoading(true);
    loadCurrentActor()
      .then(result => {
        if (active) setActor(result);
      })
      .catch(() => {
        if (active) setActor(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [location.pathname]);

  if (!webAuthEnabled()) return <>{children}</>;
  if (loading) return <LoadingSpinner />;
  if (!actor) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
